import useEventListener from '@use-it/event-listener';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { encryptionString } from '../../helpers/encryption';
import { randomString } from '../../helpers/randomString';
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import useValidation from '../../hooks/useValidation';
import Loader from '../common/Loader';
import TextField from '../common/TextField';
import { fetchDepsUnits, getDynamicFormData, getLocationDetails, getTrackingParams, loadLocations, login, resetError } from './action';
import { loginSelector } from './selector';
import { mapURL } from '../../helpers/domainURL';
import { getInstanceLogo } from '../Instance/instance';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const validate = useValidation();
  const location = useLocation();
  const config = useConfiguration();
  const storage = useSessionStorage();
  if (location.state) {
    const { email, password } = location.state;
  }
  const { isError, isSuccess, data, errorMessage, accountFlag, locationList } =
    useSelector(loginSelector);
  const trackingHistoryParams = useSelector(store => store.login.trackingHistoryParams)
  const ENTER_KEYS = [13, 'Enter'];
  // const fiveStarDomain = ['emp5stardev.overturexl.com', 'qatestemployer5star.overturexl.com', '5staremployers.overturexl.com','5starstagingemployers.overturexl.com']
  // const isFiveStar = mapURL.fiveStarDomain.includes(window.location.hostname);
  // const lifeStyleDomain = ['dynamicemployers.overturexl.com']
  // const isLifeStyle = mapURL.lifeStyleDomain.includes(window.location.hostname);
  // const isNurseEtc = mapURL.nursesEtc.includes(window.location.hostname);
  const mainLogo = getInstanceLogo();
  useEffect(() => {
    document.title = 'Overture Employer Login';
  }, []);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [formErrors, setFormErrors] = useState({});
  if (isSuccess) {
    storage.setItem('login', data);
    if (accountFlag) {
      if (!accountFlag.isCompanyDetailSaved) {
        navigate('/addcompany');
      } else if (!accountFlag.isFirstLocationCreated) {
        navigate('/addlocations', {
          state: {
            contacts: 'false',
            hideContact: true,
          },
        });
      } else if (!accountFlag.isDefaulUserSaved) {
        navigate('/adduser');
      } else {
        navigate('/openshifts');
      }
    }
  }
  if (locationList && locationList.length > 0) {
    storage.setItem('locationList', locationList);
  }

  /* useEffect(() => {
        if(email && password) {
            setFormData({
                email: email,
                password: password
            })
        }
    }, [email]); */
  //test
  const validateForm = () => {
    const result = validate('login', [
      { name: 'email', data: formData.email },
      {
        name: 'password',
        data: formData.password,
      },
    ]);
    if (result.valid) {
      setFormErrors({});
    } else {
      setFormErrors(result.errors);
    }
    return result.valid;
  };
  const updateFormValue = (target) => {
    const { name, value } = target;
    setFormData({ ...formData, [name]: value });
  };

  const handleKeyEvent = ({ key }) => {
    if (ENTER_KEYS.includes(key)) {
      const isValid = validateForm();
      if (isValid) {
        const iv = randomString(16, '0,1,2,3,4,5,6,7,8,9');
        dispatch(
          login({
            url: `${config.baseUrl}`,
            email: formData.email,
            iv: iv,
            password: encryptionString(
              config.SaltKeyForJSandAPI,
              iv,
              formData.password
            ),
            userClientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          })
        ).then(response => {
          dispatch(getTrackingParams(config.baseUrl, { ...trackingHistoryParams, userName: formData.email }, response))
        });
        dispatch(getDynamicFormData(config.baseUrl));
      }
    }
  };
  useEventListener('keydown', handleKeyEvent);
  const loginClicked = (e) => {
    e.preventDefault();
    const isValid = validateForm();
    if (isValid) {
      const iv = randomString(16, '0,1,2,3,4,5,6,7,8,9');
      dispatch(
        login({
          url: `${config.baseUrl}`,
          email: formData.email,
          iv: iv,
          password: encryptionString(
            config.SaltKeyForJSandAPI,
            iv,
            formData.password
          ),
          userClientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        })
      ).then(response => {
        if (response?.result === 1) {
          // dispatch(getLocationDetails({ url: config.baseUrl, employerUniqueId: response?.employerUniqueId }))
          // dispatch(fetchDepsUnits({ baseUrl: config.baseUrl }))
        }
        dispatch(getTrackingParams(config.baseUrl, { ...trackingHistoryParams, userName: formData.email }, response))
      })
      dispatch(getDynamicFormData(config.baseUrl));

    }
  };

  const signUpClicked = (e) => {
    e.preventDefault();
    dispatch(resetError());
    navigate('/signup');
  };

  const activate = (e) => {
    e.preventDefault();
    dispatch(resetError());
    navigate('/employerRegister');
  };

  const forgotPassword = (e) => {
    e.preventDefault();
    navigate('/forgot');
  };

  const [passwordType, setPasswordType] = useState('password');

  const [passwordInput, setPasswordInput] = useState('');

  const [iconStyleText, seticonStyleText] = useState(
    'zmdi zmdi-eye-off text-muted'
  );

  const handlePasswordChange = (evnt) => {
    setPasswordInput(evnt.target.value);
  };
  const togglePassword = () => {
    if (passwordType === 'password') {
      setPasswordType('text');
      seticonStyleText('zmdi zmdi-eye text-muted');
      return;
    }
    setPasswordType('password');
    seticonStyleText('zmdi zmdi-eye-off text-muted');
  };
  return (
    <div>
      <Loader />
      <div className="page main-background-color">
        <div className="">
          <div className="container-login100">
            <div className="wrap-login100 p-6">
              <form className="login100-form needs-validation">
                <span className="login100-form-title pb-5">
                  <a href="">
                    <img
                      style={{minWidth:"270px", maxHeight:"90px", maxWidth:"280px" }}
                      // src="assets/images/brand/Overturecommonlogo.svg"
                      src={mainLogo ? mainLogo : "assets/images/brand/EMPLOYER.png"}
                      className="header-brand-img"
                      alt=""
                    />
                  </a>
                </span>
                <span className="login100-form-title pb-5">Employer Login</span>
                {isError && (
                  <>
                    <div
                      className="toast wrap-input100 align-items-center text-white bg-danger border-0 show"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      data-bs-autohide="false"
                    >
                      <div className="logingerrormgs">
                        <div className="toast-body">
                          {errorMessage || 'Login failed! Please try again.'}
                        </div>
                      </div>
                    </div>
                    <div>&nbsp;</div>
                  </>
                )}
                <div className="panel panel-primary">
                  <div className="panel-body tabs-menu-body p-0 pt-5">
                    <div className="tab-content">
                      <div className="tab-pane active" id="tab5">
                        <div
                          class="wrap-input100 validate-input input-group"
                          id="Emailtoggle"
                        >
                          <label for="exampleInputname" class="logintextspace">
                            <h5>Email</h5>
                          </label>
                        </div>
                        <TextField
                          placeholder={'Email'}
                          type={'email'}
                          name={'email'}
                          iconClass={'zmdi zmdi-email text-muted'}
                          updateValue={updateFormValue}
                          errors={formErrors['email']}
                        />

                        <div
                          class="wrap-input100 validate-input input-group"
                          id="Passwordtoggle"
                        >
                          <label for="exampleInputname" class="logintextspace">
                            <h5>Password</h5>
                          </label>
                        </div>

                        <TextField
                          placeholder={'Password'}
                          clickeye={togglePassword}
                          type={passwordType}
                          name={'password'}
                          iconClass={iconStyleText}
                          onChange={handlePasswordChange}
                          updateValue={updateFormValue}
                          errors={formErrors['password']}
                        />

                        <div className="text-end pt-4">
                          <p className="mb-0">
                            <a
                              href="#"
                              className="text-primary ms-1"
                              onClick={forgotPassword}
                            >
                              Forgot Password?
                            </a>
                          </p>
                        </div>
                        <div className="container-login100-form-btn">
                          <a
                            href="#"
                            className="login100-form-btn btn-primary"
                            onClick={loginClicked}
                            onKeyPress={(event) => {
                              if (event.key === 'Enter') {
                                loginClicked(event);
                              }
                            }}
                          >
                            Login
                          </a>
                        </div>
                        <div className="text-center pt-3">
                          <p className="text-dark mb-0">
                            Have Activation Code?
                            <a
                              href="#"
                              onClick={activate}
                              className="text-primary ms-1"
                            >
                              Activate here
                            </a>
                          </p>
                        </div>
                        {/* <div className="text-center pt-3">
                                                    <p className="text-dark mb-0">Not a member?<a href="#"
                                                                                                  onClick={signUpClicked}
                                                                                                  className="text-primary ms-1">Sign
                                                        Up</a></p>
                                                </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
